var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShowmoreTaskMobileInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.126 9.005l.001.266c.01 1.053.073 1.993.183 2.588 0 .011.119.602.195.798.12.284.336.526.606.679a1.5 1.5 0 00.683.164c.187-.009.495-.103.716-.182l.183-.07c1.212-.482 3.53-2.055 4.418-3.018l.066-.067.292-.315c.184-.242.281-.537.281-.854 0-.284-.087-.568-.26-.798a2.676 2.676 0 00-.21-.25l-.284-.298c-.979-.991-3.097-2.382-4.195-2.842 0-.01-.683-.295-1.007-.306H9.75a1.36 1.36 0 00-1.202.744c-.065.125-.127.371-.174.587l-.086.408c-.097.656-.162 1.662-.162 2.766zM3.377 7.861c-.622 0-1.127.51-1.127 1.139 0 .628.505 1.138 1.127 1.138l2.775-.245A.888.888 0 007.036 9a.889.889 0 00-.884-.893L3.377 7.86z",
    fill: "#BDBDBD"
  })));
}

export default SvgIconShowmoreTaskMobileInactive;